
define('ldsh!modules/editor/templates/controls/page_margin', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="handle ' +
((__t = ( handleClass )) == null ? '' : __t) +
'"></div>\n<span class="handle__position handle__' +
((__t = ( handleClass )) == null ? '' : __t) +
'__position"></span>\n\n';

}
return __p
};});

